import { render } from "./renBaoPsychologicalActivity.vue?vue&type=template&id=951b59ae&scoped=true&ts=true"
import script from "./renBaoPsychologicalActivity.vue?vue&type=script&lang=ts"
export * from "./renBaoPsychologicalActivity.vue?vue&type=script&lang=ts"

import "./renBaoPsychologicalActivity.vue?vue&type=style&index=0&id=951b59ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951b59ae"]])

export default __exports__